<template>

<app-group :title="page.business_profile_prices_settings_title" :collapsed="true" class="prices-settings">

    <app-input-toggle :expand="true" :label="page.business_profile_prices_settings_toggle_label" v-model="inputs.toggle" :errored="errored.toggle" :options="tabs" />
    <app-input-toggle :expand="true" :label="page.business_profile_prices_settings_band_label" v-model="inputs.band" :errored="errored.band" :options="bands" />

    <app-group :row="true" :center="true" class="prices-settings-button">

        <app-button :success="is.saved" :fail="is.errored" :fixed="true" :text="page.business_profile_prices_settings_button_save" :disabled="!is.valid" :loading="is.submitting" v-on:click="onSaveClick" />

    </app-group>

</app-group>

</template>

<script>

import mixinForm from '@/mixin/form.js'

export default {

    mixins: [mixinForm],
    
	data: function() {

		return {
            stayAfterSave: true,
			inputs: {
                toggle: '',
                band: 0
			},
			rules: {
				toggle: {
					required: true
				}
			}
		}

    },
    
    computed: {

        tabs: function() {

            var options = {}

            this.$_.each(this.$store.getters['data'].tabs, function(tab) {
                
                if (tab.type === this.$constants.tab.price) options[tab.id] = tab.name

            }.bind(this))

            return options

        },

        bands: function() {

            return {
                0: 'n/a',
                1: '£',
                2: '££',
                3: '£££'
            }

        }

    },

	methods: {

		resetValues: function() {

            this.inputs.toggle = this.session.business.tab.prices
            this.inputs.band = this.session.business.prices.band
                
		},

		onSaveClick: function() {

			this.save('account/profile/prices/settings', this.inputs)

		}

	}

}

</script>

<style scoped>

.prices-settings {
    margin-bottom: 20px;
}

.prices-settings-button {
    margin-top: 10px;
}

</style>